module.exports = __webpack_public_path__ + "img/45.7bab77e0.gif";